import React, { Component } from "react";
import { FontAwesomeIcon }           from '@fortawesome/react-fontawesome'
import { Button, Modal, ListGroup, ListGroupItem } from "react-bootstrap";
import uniqueId       from 'lodash/uniqueId';
import { invokeGetProgramFolders, invokeSaveProgramToFolder } from "../../utils/AwsInvoke";
import "../../css/modal/ModalMoveProgramToFolder.css";
import "../../css/modal/ModalBasics.css";


export default class ModalMoveProgramToFolder extends Component {

    constructor(props) {
        super(props);

        this.state = {
            folder_id:  null,
            program_id: null,
            error_msg:  "",
            showModalSimple: false,
        };
    }

    async componentDidMount() {

        try {
            const results = await invokeGetProgramFolders();

            if(results) {
                this.setState({
                    folders: results,
                    program_id: this.props.program_id
                });
            }
        } catch (e) {
            alert(e);
        }
    }

    handleMoveProgram (uid) {
        this.setState({
            error_msg: "Updating program folders."
        })
        this.setState({
            folder_id: uid
        }, function(){
            this.handleSubmit();
        });
    }

    handleSubmit = async event => {
        var folder_id  = this.state.folder_id;
        var program_id = this.state.program_id;

        if(folder_id === null) {
            alert("Please select a folder.")
            return;
        }

        const results = await invokeSaveProgramToFolder(program_id, folder_id);

        if(results) {
            // Close Modal //
            this.props.onHide();
            this.props.getProgramList(""); //search all = ""
        } else
            this.setState({
                error_msg: "Ooops, looks like there was an error. Try again."
            })
    }

    renderFolderList (folders) {

        if(folders) {
            var list = Object.keys(folders).map( (index, name) => {
                            return <ListGroupItem
                                                  key={uniqueId()}
                                                  onClick={() => this.handleMoveProgram(folders[index].uid)}>
                                        { folders[index].name }
                                    </ListGroupItem>
                            }
                        )
            return <ListGroup>
                        { list }
                    </ListGroup>

        } else
            return (
                <ListGroup>
                    <ListGroupItem>
                        You have not created any folders yet.
                    </ListGroupItem>
                </ListGroup>
                )
    }
    render() {
        var notes = this.props.notes;

        return (
            <Modal
                    show      = {this.props.show}
                    onHide    = {this.props.onHide}
                    className = "modalBasics"
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="fontSize26px">
                        <FontAwesomeIcon icon="arrows-alt" className="modalBasicsTitleIcon" />
                        <span className="modalBasicsTitle">
                             Move Program
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className="modalBasicsBody">
                          Move your program to a folder by selecting one of the available folders below.
                          <br/><br/>
                          <div>
                              <div className="modalFormLabelBody">Folders</div>
                          { this.renderFolderList(this.state.folders) }
                          </div>
                          { this.state.error_msg }
                          <br/>
                    </span>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="modalBasicsBtnClose" onClick={this.props.onHide}>Cancel</Button>
                </Modal.Footer>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalMoveProgramToFolder.js